import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

function BranchDetailsForm({ formData, setFormData, branch, edit }) {
 
  useEffect(() => {
    if (edit) {
      setFormData({
        ...formData,
        name: branch.name,
        address: branch.address
      })
    }
  }, [])

  return (
    <div>
      <Box component="form" noValidate sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="given-name"
              name="name"
              fullWidth
              value={formData.name || ""}
              id="name"
              label="Name"
              size="small"
              autoFocus
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              id="address"
              label="Address"
              name="address"
              value={formData.address || ""}
              autoComplete="family-name"
              size="small"
              onChange={(e) => {
                setFormData({ ...formData, address: e.target.value });
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default BranchDetailsForm;